class BmAnnouncementTimer extends HTMLElement {
  connectedCallback() {
    this.deadline = Date.parse(this.dataset.deadline);
    this.dismissKey = 'bm-announce-dismissed-' + this.dataset.sectionId;
    this.valueEl = this.querySelector('[data-bm-countdown-value]');
    this.dismissBtn = this.querySelector('[data-bm-dismiss]');

    this.syncHeight();
    this._resizeObserver = new ResizeObserver(() => this.syncHeight());
    this._resizeObserver.observe(this);
    window.addEventListener('resize', () => this.syncHeight());

    this.syncMarqueeSpeed();
    window.addEventListener('resize', () => this.syncMarqueeSpeed());

    if (this.dismissBtn) {
      this.dismissBtn.addEventListener('click', () => {
        try { sessionStorage.setItem(this.dismissKey, '1'); } catch (e) {}
        this.setAttribute('hidden', '');
        document.documentElement.style.setProperty('--bm-announce-h', '0px');
      });
    }

    try {
      if (sessionStorage.getItem(this.dismissKey) === '1') {
        this.setAttribute('hidden', '');
        document.documentElement.style.setProperty('--bm-announce-h', '0px');
        return;
      }
    } catch (e) {}

    if (!this.deadline || Number.isNaN(this.deadline)) {
      if (this.valueEl) this.valueEl.closest('.bm-announce__countdown')?.setAttribute('hidden', '');
      return;
    }

    this.tick();
    this._interval = setInterval(() => this.tick(), 1000);
  }

  syncHeight() {
    if (this.hasAttribute('hidden')) return;
    document.documentElement.style.setProperty('--bm-announce-h', this.offsetHeight + 'px');
  }

  syncMarqueeSpeed() {
    const track = this.querySelector('[data-bm-ticker-track]');
    const message = this.querySelector('.bm-announce__message');
    if (!track || !message) return;
    const pxPerSecond = 60;
    const oneCopyWidth = message.getBoundingClientRect().width;
    const duration = Math.max(8, oneCopyWidth / pxPerSecond);
    track.style.setProperty('--bm-marquee-duration', `${duration}s`);
  }

  disconnectedCallback() {
    clearInterval(this._interval);
    this._resizeObserver?.disconnect();
  }

  tick() {
    const remaining = this.deadline - Date.now();
    if (remaining <= 0) {
      this.setAttribute('hidden', '');
      clearInterval(this._interval);
      return;
    }
    const h = Math.floor(remaining / 3600000);
    const m = Math.floor((remaining % 3600000) / 60000);
    const s = Math.floor((remaining % 60000) / 1000);
    const pad = (n) => String(n).padStart(2, '0');
    if (this.valueEl) this.valueEl.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
  }
}

customElements.define('bm-announcement-timer', BmAnnouncementTimer);
